import type { NotificationInstance } from 'antd/es/notification/interface';
import { showParamWarning } from '../components/showParamWarning';

type CopiedParameters = {
  unknownBillingParameters: Array<{ shortName: string; longName: string }>;
  unavailableParameters: string[];
};

/** What changed for the parameters of a copied Anforderung, named as the Zuweiser's lists name them. */
export const showCopyWarnings = (notification: NotificationInstance, copied: CopiedParameters, flipParamNames: boolean) => {
  if (copied.unknownBillingParameters.length) {
    showParamWarning(
      notification,
      'Verrechnungssituation geändert',
      'Für folgende Parameter hat sich die Verrechnungssituation geändert:',
      copied.unknownBillingParameters.map(it => (flipParamNames ? it.longName : it.shortName))
    );
  }
  if (copied.unavailableParameters.length) {
    showParamWarning(
      notification,
      'Parameter nicht verfügbar',
      'Folgende Parameter stehen nicht zur Verfügung:',
      copied.unavailableParameters
    );
  }
};
